import styled from "styled-components";
import { useEffect, useState } from "react";
import { PlainButtonBar, PrimaryButton, SecondaryButton } from "../components/Button";
import { Label, Spacer } from "../editor/EditorHelpers";
import { useNavigate } from "react-router-dom";
import { TextEditor } from "../components/TextEditor";
import { KEY_OWN_CID, KEY_TOKEN } from "./challengeModel";
import { ChallengeLearnMore, StatusText } from "./ChallengeHelpers";
import { useTranslation } from "react-i18next";


function setThemeColor(color) {
  let themeColor = document.querySelector('meta[name="theme-color"]');
  if (!themeColor) {
    themeColor = document.createElement('meta');
    themeColor["name"] = 'theme-color';
    document.head.appendChild(themeColor);
  }
  themeColor.setAttribute('content', color);
}

export default function EmailPromptChallenge() {
  const { t } = useTranslation();
  const [email, setEmail] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [isLearnMoreOpen, setLearnMoreOpen] = useState(false);
  const navigate = useNavigate();
    
  useEffect(() => {
    const rootElement = document.getElementById('root');    
    rootElement.classList.add("challenge-green");
    const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (isDark) {
      setThemeColor('hsl(120, 40%, 18%)');
    } else {
      setThemeColor('hsl(120, 40%, 18%)');
    }
    return () => {
      rootElement.classList.remove("challenge-green");
      if (isDark) {
        setThemeColor('#002266');
      } else {
        setThemeColor('#003399');
      }
      }
  }, []);

  const handleJoinSubmit = (e) => {
    e.preventDefault();
    if (email.length === 0) {
      setError(t('challenge.email-is-required.error'))
    } else {
      recoverChallenge();
    }
  }

  const setEmailAndMaybeClearError = (v: string) => {
    if (v.length > 0) {
      setError("");
    }
    setEmail(v);
  }

  const handleBack = () => {
    navigate(-1);
  };

  const recoverChallenge = () => {
    const formData: Record<string, string> = {
      email,
    };
    setLoading(true);
    fetch('/api/recover_or_create_challenge.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(formData)
    })
      .then(response => response.json())
      .then(data => {
        setLoading(false);
        if (data.token) {
          console.log("recover_or_create_challenge.php token:", data.token, data.cid);
          localStorage.setItem(KEY_OWN_CID, data.cid);
          localStorage.setItem(KEY_TOKEN, data.token);
          navigate("/challenge/" + data.cid);
        } else if (data.status) {
          console.log("recover_or_create_challenge.php status:", data.status);
          if (data.status === "exists") {
            navigate("/challenge/recover")
          }
        } else {
          console.log("recover_or_create_challenge.php error:", data.error);
          if (data.error === "No such email") {
            setError(t("challenge.no-such-email.error"))
          }
        }
      })
      .catch(error => {
        console.error('Error:', error);
        setLoading(false);
      });
  }



  return (
    <div className="generic-page" >
      <div className="narrow-content" style={{
        //fontFamily: "'Times New Roman', Times, serif"
      }}>
        <Header>{t('challenge.email-prompt.header')}</Header>
        <Subheader>
          {t('challenge.email-prompt.subheader')}
        </Subheader>
        <form onSubmit={handleJoinSubmit}>
          <FormContainer>
            <Label>{t('email.label')}</Label>
            <TextEditor
              value={email} onChange={(v) => setEmailAndMaybeClearError(v)} />

            {error && <StatusText>{error}</StatusText>}
            <PlainButtonBar style={{marginTop: '1.8rem'}}>
              <Spacer style={{flexGrow: 1}} />
              <SecondaryButton type='button' onClick={handleBack}>{t('back.button')}</SecondaryButton>
              <SecondaryButton type='button' onClick={() => setLearnMoreOpen(true)}>{t('learn-more.button')}</SecondaryButton>
              <PrimaryButton disabled={loading} type='submit'>{t('challenge.request-log-in-link.button')}</PrimaryButton>
              <Spacer style={{flexGrow: 1}} />
            </PlainButtonBar>
          </FormContainer>
        </form>
        {isLearnMoreOpen && <ChallengeLearnMore onClose={() => setLearnMoreOpen(false)} />}
      </div>
    </div>
  )
}

const Header = styled.h1`

`

const Subheader = styled.div`
  font-weight: 400;
  font-size: 1.15rem;
  max-width: 450px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  margin-bottom: 1.5rem;
`

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 450px;
  margin-left: auto;
  margin-right: auto;
  align-items: left;
`
